import { Box, Chip, TableCell, TableRow } from '@mui/material'
import * as React from 'react'
import { FC } from 'react'
import { WorkItemTask } from '../../../types/Work/WorkItemTask'
import AnimatedNumberField from '../../core/AnimatedNumberField'
import { formatLocaleShortDateTime, formatPercent } from '../../../services/CommonServices/DataFormatters'
import { StyledTableCell } from '../../core/StyledTableCell'
import { useQCContext } from '../QCContext'
import { useProjectFeaturesContext } from '../../project/contexts/ProjectFeaturesContext'
export interface QCTaskRowProps {
	task: WorkItemTask
}

export const QCTaskRow: FC<QCTaskRowProps> = ({ task }: QCTaskRowProps) => {
	const { request } = useQCContext()
	const {projectTimeZone} = useProjectFeaturesContext()
	return task.reworks && task.reworks.length > 0 ? (
		<TableRow style={{ background: '#fff' }}>
			<TableCell />
			<StyledTableCell align='center'>
				<Chip label={'rework'} variant={'rework chip'} />
			</StyledTableCell>
			<TableCell />
			<TableCell>{task.reworks[0].name}</TableCell>
			<TableCell />
			<TableCell>
				<b>{formatLocaleShortDateTime(request?.requestedAt ?? null, projectTimeZone ?? 'UTC')}</b>
			</TableCell>
			<TableCell />
			<TableCell>
				<b>{request?.comment}</b>
			</TableCell>
			<TableCell />
			<TableCell />
			<TableCell />
			<TableCell />
			<TableCell />
			<TableCell />
			<TableCell />
			<TableCell />
			<TableCell />
			<TableCell />
			<TableCell align='center'>{task.reworks[0].burnedHours}</TableCell>
			<TableCell />
		</TableRow>
	) : (
		<TableRow style={{ background: '#fff' }}>
			<TableCell />
			<StyledTableCell align='center'>
				<Chip label={'task'} variant={'task'} />
			</StyledTableCell>
			<TableCell />
			<TableCell>{task.name}</TableCell>
			<TableCell />
			<TableCell>
				<b>{formatLocaleShortDateTime(request?.requestedAt ?? null, projectTimeZone ?? 'UTC')}</b>
			</TableCell>
			<TableCell />
			<TableCell>
				<b>{request?.comment}</b>
			</TableCell>
			<TableCell />
			<TableCell />
			<TableCell align='center'>
				<AnimatedNumberField value={task.quantityComplete} />
			</TableCell>
			<TableCell />
			<TableCell />
			<TableCell align='center'>
				<AnimatedNumberField value={task.quantityRemaining} />
			</TableCell>
			<TableCell align='center'>
				<AnimatedNumberField value={task.percentComplete} formatter={formatPercent} />
			</TableCell>
			<TableCell align='center'>
				<AnimatedNumberField value={task.quantityInspected} />
			</TableCell>
			<TableCell />
			<TableCell />
			<TableCell align='center'>{task.burnedHours}</TableCell>
			<TableCell />
		</TableRow>
	)
}
